<template>
  <div>
    <form enctype="multipart/form-data" novalidate>
        <input
            id="azFileSelector"
            type="file"
            class="input-file d-none"
            :name="uploadFieldName"
            :accept="accept"
            @change="onSelectFiles($event.target.files)"
        />
        <div class="center">
            <slot></slot>
        </div>
    </form>
  </div>
</template>

<script>
import {mimeTypes} from "@/commons/constants";
import {mapState} from "vuex";
import {pdfPossuiSenha} from "@/commons/utils/PdfUtils";

export default {
  name: 'CredenciamentoUnicoFileUpload',
  props: {
    docsJaInseridosProposta:[],
    docsJaInseridos: [],
    urlPersonalizadaUpload: {
      type: String,
      default: null
    },
    accept: {
      type: String,
      default: '*'
    },
    repository: {
      type: String,
      required: true
    },
    thumbnail: {
      type: Boolean,
      default: false
    },
    height: {
      type: String,
      default: '200px'
    },
    multiple: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      uploadFieldName: 'file',
      retornosApiPersonalizada: []
    }
  },
  computed: {
    ...mapState(['file'])
  },
  methods: {
    calcFileSize(bytes, unit) {
      const k = 1024
      return parseFloat((bytes / Math.pow(k, unit)).toFixed(2))
    },
    createFormData(file) {
      const formData = new FormData()
      formData.append(this.uploadFieldName, file)
      formData.append('repository', this.repository)
      formData.append('thumbnail', this.thumbnail)
      return formData
    },
    createPayload(file) {
      return {
        formData: this.createFormData(file),
        filename: file.name
      }
    },
    getMaxSizeConfig() {
      const fileConfig = this.$store.state.loki.file
      const maxSize = fileConfig.maxSize.replace(/([A-Za-z]+)/g, '')
      const unit = ['B', 'KB', 'MB', 'GB', 'TB'].indexOf(fileConfig.maxSize.replace(/\d+/g, '').toUpperCase())
      return {maxSize, unit}
    },
    isFileBiggerThanExpected(file) {
      const {maxSize, unit} = this.getMaxSizeConfig()
      const fileSize = this.calcFileSize(file.size, unit)
      return fileSize > maxSize
    },
    async onSelectFiles(fileList) {

      if (!fileList.length) {
        return
      }

      const files = []
      const ignoredUploadFiles = []
      const ignoredUploadFilesLock = []
      const filePromises = []

      Object.keys(fileList).forEach(key => {
        const item = fileList[key]
        const extensaoDesconecida = !item.type

        if ((this.accept === '*' || this.accept.includes(item.type)) && !extensaoDesconecida) {
          files.push(item)
        } else {
          ignoredUploadFiles.push(item)
        }

        filePromises.push(pdfPossuiSenha(item).then(possuiSenha => {
          if (possuiSenha) {
            ignoredUploadFilesLock.push(item)
          }
        }))
      })

      await Promise.all(filePromises)

      const qtdAceitos = files.length
      const qtdIgnorados = ignoredUploadFiles.length
      const qtdIgnoradosLock = ignoredUploadFilesLock.length
      this.notificarArquivosNaoInseridos(qtdAceitos, qtdIgnorados, qtdIgnoradosLock)

      if (qtdIgnorados === 0 && qtdIgnoradosLock === 0) {
        this.uploadFiles(files)
        this.resetSelectedFiles()
      }
    },
    notificarArquivosNaoInseridos(qtdAceitos, qtdIgnorados, qtdIgnoradosLock) {
      if (qtdIgnorados > 0 || qtdIgnoradosLock > 0) {
        let {extensoesValidas, multiplasExtensoes} = this.converterAcceptEmTextoLegivel(this.accept)
        let mensagemCompleta = ''
        if (qtdAceitos === 0) {
          if (qtdIgnorados === 1) {
            mensagemCompleta += 'O arquivo não foi anexado. '
          } else {
            mensagemCompleta += 'Nenhum arquivo foi anexado. '
          }
        } else {
          if (qtdIgnorados === 1 || qtdIgnoradosLock === 1) {
            mensagemCompleta += 'Um arquivo não foi anexado. '
          } else {
            mensagemCompleta += 'Alguns arquivos não foram anexados. '
          }
        }

        if (qtdIgnoradosLock > 0) {
          mensagemCompleta += `O formato ${extensoesValidas} é aceito apenas sem senha.`
        } else if (this.accept !== '*') {
          mensagemCompleta += `Apenas ${multiplasExtensoes ? `os formatos ${extensoesValidas} são aceitos.` : `o formato ${extensoesValidas} é aceito.`}`
        } else {
          mensagemCompleta += `Só serão aceitos arquivos com extensão. Exemplo: arquivo.pdf, arquivo.docx e etc...`
        }
        this.mostrarNotificacaoErro(mensagemCompleta)
      }
    },
    converterAcceptEmTextoLegivel(accept) {
      const extensoesAccept = accept.replace(/\s+/g, '').split(',')
      let extensoesArray = Object.values(mimeTypes).filter(mime => extensoesAccept.some(ext => mime.valor.includes(ext))).map(mime => mime.extensao)
      const extensoesValidas = [extensoesArray.slice(0, -1).join(', '), extensoesArray.slice(-1)[0]].join(extensoesArray.length < 2 ? '' : ' e ');
      return {
        extensoesValidas: extensoesValidas,
        multiplasExtensoes: extensoesAccept.length > 1
      }
    },
    openFileSelector() {
      document.getElementById('azFileSelector').click()
    },
    uploadFiles(fileList) {
      let apiDefault0 = this.file
      if (this.urlPersonalizadaUpload) {
        const apiCustom = {
          api: this.urlPersonalizadaUpload,
          maxSize: '100Mb'
        }
        this.setApiArquivos(apiCustom)
      }
      Array.from(Array(fileList.length).keys()).forEach(async (x, idx, array) => {
        const file = fileList[x]
        try {
          //this.validarArquivosHomonimos(file);

          if (this.isFileBiggerThanExpected(file)) {
            this.throwFileExceedMaxLimitSizeEvent(file)
          } else {
            const payload = this.createPayload(file)
            if (this.urlPersonalizadaUpload) {
              const retorno = await this.uploadFile(payload)
              this.retornosApiPersonalizada.push(retorno)
            } else {
              await this.uploadFile(payload)
            }
          }
          if (idx === array.length - 1) {
            //this.$emit('uploadArquivoCompleto')
            this.setApiArquivos(apiDefault0)
          }
        } catch (e) {
          alert("Já existe um arquivo com o nome " + file.name + " inserido anteriormente.");
        }
      })
    },
    resetSelectedFiles() {
      document.getElementById('azFileSelector').value = ''
    },
    throwFileExceedMaxLimitSizeEvent(file) {
      this.$emit('error', {
        type: 'FILE_EXCEEDED_MAX_SIZE_LIMIT',
        filename: file.name
      })
    },
    // validarArquivosHomonimos(file) {
    //     console.log(this.docsJaInseridos)
    //     console.log(file)
    //   var nomeJaPresente = this.docsJaInseridos.some(function (item) {
    //     return item.descricao === file.name;
    //   });
    //
    //   if (nomeJaPresente) {
    //     throw new Error("O atributo name já está presente no array.");
    //   }
    //
    //   var nomeJaPresenteProposta = this.docsJaInseridosProposta.some(function (item) {
    //     return item.descricao === file.name;
    //   });
    //
    //   if (nomeJaPresenteProposta) {
    //     throw new Error("O atributo name já está presente no array.");
    //   }
    // }
  }
}
</script>

<style scoped lang="stylus">
</style>
